import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

class Overlay extends Component {

    preventScroll(e) {
        return e.preventDefault()
    }

    lockScroll() {
        document.getElementsByTagName('html')[0].style.overflowY = 'hidden' 
    }

    render() {
        const { overlayValue } = this.props
        if(!overlayValue.visible) {return null}
        if (overlayValue.visible) { this.lockScroll() }

        return (
            <Wrapper>
                {overlayValue.component}
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    overlayValue: state.overlayValue,
})

export default connect(mapStateToProps, null)(Overlay);

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    min-height: 100vh;
    z-index: 100;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
`